import { render, staticRenderFns } from "./copywriting.vue?vue&type=template&id=67198573&scoped=true&"
import script from "./copywriting.vue?vue&type=script&lang=js&"
export * from "./copywriting.vue?vue&type=script&lang=js&"
import style0 from "./copywriting.vue?vue&type=style&index=0&id=67198573&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67198573",
  null
  
)

export default component.exports